module.exports = __webpack_public_path__ + "img/main-flower3.85834841.svg";